import React from 'react';
import { Sparkles } from 'lucide-react';
import { differentiators } from '../mock';

const DifferentiatorsSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#0B0F14] mb-6">
            What Makes Us Different
          </h2>
          <p className="text-xl text-[#5F6B7A] max-w-3xl mx-auto">
            Our commitment goes beyond compliance—it's about understanding and supporting each child
          </p>
        </div>

        {/* Staggered Cards */}
        <div className="space-y-6">
          {differentiators.map((item, index) => (
            <div 
              key={index}
              className={`flex items-start gap-6 p-8 rounded-3xl backdrop-blur-xl bg-gradient-to-r ${
                index % 2 === 0 
                  ? 'from-white/80 to-[#0077BE]/5 ml-0 md:ml-12' 
                  : 'from-[#00B4D8]/5 to-white/80 mr-0 md:mr-12'
              } border border-white/50 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-102 group`}
              style={{
                animationDelay: `${index * 100}ms`
              }}
            >
              <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-[#0077BE] to-[#00B4D8] flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <Sparkles className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#0B0F14] mb-3">
                  {item.title}
                </h3>
                <p className="text-lg text-[#5F6B7A] leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DifferentiatorsSection;
